import { useEffect, useState } from "react";
import { Download, X, Smartphone } from "lucide-react";
import { useInstallAvailable, promptInstall, isStandalone } from "@/lib/pwa";
import { trackEvent } from "@/lib/audit";

const DISMISS_KEY = "ss2026_install_dismiss";

export function InstallBanner() {
  const avail = useInstallAvailable();
  const [dismissed, setDismissed] = useState(true);
  const [installing, setInstalling] = useState(false);

  useEffect(() => {
    if (isStandalone()) {
      setDismissed(true);
      return;
    }
    const d = localStorage.getItem(DISMISS_KEY);
    setDismissed(d === "1");
  }, []);

  if (!avail || dismissed) return null;

  const onInstall = async () => {
    setInstalling(true);
    const res = await promptInstall();
    setInstalling(false);
    if (res === "accepted") {
      void trackEvent("pwa_installed", { source: "banner" });
      setDismissed(true);
    } else if (res === "dismissed") {
      localStorage.setItem(DISMISS_KEY, "1");
      setDismissed(true);
    }
  };

  const onClose = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="fixed inset-x-3 bottom-24 z-40 lg:bottom-6 lg:left-auto lg:right-6 lg:max-w-sm">
      <div className="relative overflow-hidden rounded-2xl border border-border/60 glass p-3 shadow-[0_20px_60px_-10px_rgba(0,0,0,0.7)]">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[oklch(0.58_0.24_27)] to-[oklch(0.7_0.22_15)]">
            <Smartphone className="h-5 w-5 text-white" />
          </div>
          <div className="flex-1">
            <div className="text-[13px] font-bold leading-tight">Instala VerseSport</div>
            <div className="mt-0.5 text-[11px] text-muted-foreground">
              Vive el Mundial 2026 como app nativa.
            </div>
            <button
              onClick={onInstall}
              disabled={installing}
              className="mt-2 inline-flex items-center gap-1.5 rounded-lg bg-primary px-3 py-1.5 text-[11px] font-bold text-primary-foreground hover:opacity-90 disabled:opacity-50"
            >
              <Download className="h-3.5 w-3.5" />
              {installing ? "Instalando…" : "Instalar App"}
            </button>
          </div>
          <button
            onClick={onClose}
            aria-label="Cerrar"
            className="text-muted-foreground hover:text-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
